import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '../../../../../../../../../core/animations';

// Util files
import { displayValues } from '../../../../../../utils';
import { SideNavService } from '../../../sidenav.service';

@Component({
  selector: 'spekwo-solution-description',
  templateUrl: './solution-description.component.html',
  styleUrls: ['./solution-description.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class SolutionDescriptionComponent implements OnInit {

  screen :string ='ViewOrEditDb';
  displayValues = displayValues;

  constructor(private _sideNavService: SideNavService
  ) { }

  ngOnInit() {
    //To fetch All solution lists initially while entering into the page
    this._sideNavService.onSolutionInfo.next(true);
  }

  getSelectedSolution(event){
    
  }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/solution-description/solution-description.component.ts